// Parses a date string using a strftime-like format (%d, %m, %Y, %b, %B)
// and returns it as YYYY-MM-DD.
export function formatDate(inputDate, format) {
  const monthNames = {
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11,
  };

  const fullMonthNames = {
    january: 0,
    february: 1,
    march: 2,
    april: 3,
    may: 4,
    june: 5,
    july: 6,
    august: 7,
    september: 8,
    october: 9,
    november: 10,
    december: 11,
  };

  // Create a mapping for the format specifiers and corresponding regex patterns
  const regexMap = {
    "%d": "(\\d{1,2})",
    "%m": "(\\d{1,2})",
    "%Y": "(\\d{4})",
    "%b": "([a-zA-Z]{3})",
    "%B": "([a-zA-Z]+)",
  };

  // Replace format specifiers in the format string with their regex equivalents
  let regexPattern = format;
  if (!regexPattern) {
    regexPattern = "%d-%m-%Y";
  }
  for (const key in regexMap) {
    regexPattern = regexPattern.replace(new RegExp(key, "g"), regexMap[key]);
  }

  // Create a regular expression to match the input date
  const dateRegex = new RegExp(`^${regexPattern}$`);
  const match = inputDate.match(dateRegex);

  if (!match) {
    return "Invalid Date Format";
  }

  let day, month, year;
  let matchIndex = 1; // Keep track of which match group we are on

  // Iterate over the format string and extract the parts
  for (let i = 0; i < format?.length; i++) {
    if (format[i] === "%") {
      const specifier = format.slice(i, i + 2); // Get the full specifier (e.g., %d, %m)

      const value = match[matchIndex++]; // Get the corresponding value from the regex match

      switch (specifier) {
        case "%d":
          day = parseInt(value, 10);
          break;
        case "%m":
          month = parseInt(value, 10) - 1; // month is 0-based in JavaScript
          break;
        case "%Y":
          year = parseInt(value, 10);
          break;
        case "%b": // abbreviated month names
          month = monthNames[value.toLowerCase()];
          break;
        case "%B": // full month names
          month = fullMonthNames[value.toLowerCase()];
          break;
        default:
          return "Invalid Date Format";
      }

      i++; // Skip over the next character since we processed the whole specifier
    }
  }

  // Check if day, month, or year are invalid
  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return "Invalid Date";
  }

  // Create the date object
  const date = new Date(year, month, day);

  // Check if the created date is invalid
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Format the date as YYYY-MM-DD
  const formattedYear = date.getFullYear();
  const formattedMonth = String(date.getMonth() + 1).padStart(2, "0");
  const formattedDay = String(date.getDate()).padStart(2, "0");

  return `${formattedYear}-${formattedMonth}-${formattedDay}`;
}
